import http from '@/requests/http'

class TransferLog {
  static history (params) {
    return http.post('transfers/logs/history', params)
  }
}

export default TransferLog
